export default __webpack_public_path__ + "static/media/shoppingbag.15d425d8.svg";